module.exports = __webpack_public_path__ + "static/media/eh.3b662831.svg";